<template>
  <v-dialog v-model="isShow" scrollable persistent :overlay="false" max-width="500px" transition="dialog-transition">
    <v-card color="success" dark>
      <v-card-text>
        努力加载中。。。。
        <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<style scoped>

</style>

<script>
  import GhProgress from "./ghProgress.ts";
  export default GhProgress;
</script>